var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Watch } from "vue-facing-decorator";
import { SMTPImportSettingsClient, SMTPImporterClient, SitesClient, CompaniesClient, GetSMTPImporterSettingsListPaginatedQuery, PaginatedEnumerableOfSMTPImporterSettingsModel, SMTPImporterSettingsModel, SMTPImporterKeyWordLocation, CreateSMTPImporterSettingCommand, UpdateSMTPImporterSettingCommand } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import { DateHelper } from "@/app/utils/date-helper";
const smtpImportSettingsClient = new SMTPImportSettingsClient(window.apiUrl);
const smtpImporterClient = new SMTPImporterClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
let SiteVue = class SiteVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.working = false;
        this.searchAttempted = false;
        // models
        this.query = new GetSMTPImporterSettingsListPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
        });
        this.data = new PaginatedEnumerableOfSMTPImporterSettingsModel();
        this.lastDateTime = null;
        this.lastDateTimeLoaded = false;
        // arrays
        this.companies = [];
        this.allSites = [];
        this.keyWordlocations = [
            { value: SMTPImporterKeyWordLocation.Header, text: `Header` },
            { value: SMTPImporterKeyWordLocation.Body, text: `Body` },
            { value: SMTPImporterKeyWordLocation.Subject, text: `Subject` },
            { value: SMTPImporterKeyWordLocation.FileName, text: `File Name` }
        ];
        this.datePickerConfig = DateHelper.GetDefaultDatePickerConfig(true);
    }
    created() {
        // data will be loaded only after we get lookups.
        this.getLookups();
    }
    ;
    // get
    search() {
        if (this.working)
            return;
        if (!this.query)
            return;
        this.working = true;
        smtpImportSettingsClient
            .getListPaginated(this.query)
            .then(response => {
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    saveLastDateTime() {
        if (!this.lastDateTimeLoaded)
            return;
        try {
            if (isNaN(Date.parse(this.lastDateTime.toString())))
                return;
        }
        catch (_a) {
            return;
        }
        try {
            console.log("saveLastDateTime", this.lastDateTime);
            var date = this.lastDateTime ? DateHelper.convertToDate(this.lastDateTime.toString()) : null;
            if (date)
                smtpImporterClient.setLastProcessDateTime(date);
        }
        catch (ex) {
            Notifier.onError("Error saving Date/Time");
            console.error(ex);
        }
    }
    getLookups() {
        companyClient
            .getListGET()
            .then((response) => {
            this.companies = [{ value: null, text: TextHelper.emptyListItemName }].concat((response || []).map((item) => {
                return {
                    value: item.companyId || null,
                    text: item.companyName || ""
                };
            }));
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.search();
        });
        siteClient
            .getListGET()
            .then((response) => {
            this.allSites = response;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.search();
        });
        smtpImporterClient
            .getLastProcessDateTime()
            .then((response) => {
            this.lastDateTime = response;
            this.lastDateTimeLoaded = true;
        });
    }
    ;
    // set
    add() {
        let region = new SMTPImporterSettingsModel({
            id: 0,
            keyWord: null,
            keyWordLocation: SMTPImporterKeyWordLocation.Header,
            companyId: 0,
            siteId: 0,
            whenCreated: new Date(),
            whenDeleted: new Date(),
        });
        if (!this.data.records)
            this.data.records = new Array();
        this.data.records.unshift(region);
    }
    ;
    save(setting) {
        if (!setting.keyWord) {
            Notifier.onError("Please enter a key work.");
            return;
        }
        if (!setting.companyId) {
            Notifier.onError("Please select a Company.");
            return;
        }
        if (!setting.siteId) {
            Notifier.onError("Please select a Site.");
            return;
        }
        let promise = () => {
            return setting.id
                ? smtpImportSettingsClient.update(setting.id, new UpdateSMTPImporterSettingCommand({ requestModel: setting }))
                : smtpImportSettingsClient.add(new CreateSMTPImporterSettingCommand({ requestModel: setting }));
        };
        this.working = true;
        promise()
            .then(() => {
            Notifier.onOk();
            this.search();
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    purge(setting) {
        if (!setting.id && this.data.records) {
            this.data.records.splice(this.data.records.indexOf(setting), 1);
            return;
        }
        this.$confirmModal.show("Are you sure that you want to permanently delete this setting? This action cannot be undone.", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            smtpImportSettingsClient
                .delete(setting.id)
                .then(() => {
                Notifier.onOk();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.search();
            });
        });
    }
    ;
    // computed
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    sites(companyId) {
        var filteredSites = this.allSites.filter(item => item.companyId == companyId);
        var sites = [{ value: null, text: TextHelper.emptyListItemName }].concat((filteredSites || []).map((item) => {
            return {
                value: item.siteId || null,
                text: item.siteName || ""
            };
        }));
        return sites;
    }
};
__decorate([
    Watch("query.pageNo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SiteVue.prototype, "search", null);
__decorate([
    Watch("lastDateTime"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SiteVue.prototype, "saveLastDateTime", null);
SiteVue = __decorate([
    Component({
        name: "SMTPImporterSettingsVue"
    })
], SiteVue);
export default SiteVue;
